const isSSL = location.href.includes("https") ? 'https' : 'http';
const socketWpp = io.connect(`${isSSL}://${location.hostname}:4000`);
const socketWebChat = io.connect(`${isSSL}://${location.hostname}:4003`, {
	query: {
		source: "management"
	}
});

module.exports = {
	socketWpp,
	socketWebChat
}
